import { sagas as alertSagas } from './modules/alerts'

export default [...alertSagas]
